import Marquee from "react-fast-marquee";
import { useLang } from "../i18n";

export const MarqueeBand = () => {
  const { t } = useLang();
  return (
    <div
      data-testid="editorial-marquee"
      className="border-y border-border bg-brand-bone py-6"
    >
      <Marquee speed={38} gradient={false} autoFill>
        {t("marquee").map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="px-8 font-serif text-3xl font-medium tracking-tight text-brand-blue md:text-4xl">
              {item}
            </span>
            <span className="text-2xl text-brand-timber">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};
